import { useEffect } from "react";

import { setConfig } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import useLogout from "core/custom-hooks/useLogout";

import * as Utils from "core/common/utils";

import { CONFIG_STORAGE_KEY } from "core/common/constants/localstorage";

export default function useConfig() {
    const configInStorage = !!localStorage.getItem(CONFIG_STORAGE_KEY);
    const hasToken = Utils.HasAccessToken();

    const { dispatch, state } = useStore();
    const { cfg } = state;
    const { handleLogout } = useLogout();

    useEffect(() => {

        if (hasToken) {
            if (configInStorage) {

                const parsed = JSON.parse(localStorage.getItem(CONFIG_STORAGE_KEY))

                dispatch(setConfig(parsed));

                console.debug("Configuraion is ready");
            }
            else {
                //handleLogout();
                console.debug("Configuraion is lost - disconnecting...");
                return;
            }
        } else {
            dispatch(setConfig(null));
        }

        // eslint-disable-next-line 
    }, [hasToken, configInStorage])

    return {
        ready: !!cfg
    };
}